import { FC } from "react";
import { useFirebase } from "../../hooks/useFirebase";
import { NotificationPermissionPopup } from "./styled.styles";
import { classNames } from "helpers/themeHelpers";
import { useTheme } from "styled-components";
import Image from "../Image";
import { getCustomThemeValue } from "helpers/osHelpers";
import { useRouter } from "next/router";
import { isShobiddak } from "helpers/osHelpers";
import Head from "next/head";

const FirebaseFCM: FC = () => {
  const { showUi, onClickYes, onClickNo } = useFirebase();
  const { translations, isMobile, isDesktop, locale } = useTheme();
  const router = useRouter();
  if (!showUi || router?.query?.webview === "1") return null;
  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          href={`${process.env.NEXT_PUBLIC_PUBLIC_FOLDER_CDN}/images/${
            isShobiddak()
              ? "shobiddakLogo/shobiddakLogoMobile.svg"
              : "openSooqLogo/osLogoSquare.svg" 
          }`}
        />
      </Head>
      {showUi && (
        <NotificationPermissionPopup
          id="notificationPermissionPopup"
          {...classNames(
            "fixed m-auto",
            isDesktop && "font-14 whiteBg p-8",
            isMobile && "width-100 p-16",
            isMobile && locale === "en" && "font-13",
            isMobile && locale === "ar" && "font-14"
          )}
        >
          <div
            {...classNames(
              "flex",
              isMobile && "p-8 mobileShadow whiteBg radius-8 relative"
            )}
          >
            <div className="center width-25">
              <Image
                alt="Logo"
                src={getCustomThemeValue("logoSquare")}
                width={isDesktop ? 65 : 55}
                height={isDesktop ? 65 : 55}
                {...classNames(
                  isMobile && "relative radius-8",
                  isShobiddak() && "noImgFit"
                )}
              />
            </div>
            <div {...classNames(isMobile && "ps-8 whiteBg")}>
              {isDesktop && (
                <div className="bold mb-8">
                  {isShobiddak()
                    ? translations.firebaseModal.shobiddakTitle
                    : translations.firebaseModal.title}
                </div>
              )}
              <p {...classNames(isDesktop && "font-13")}>
                {translations.firebaseModal.subTitle}
              </p>
              <div className="notiButtons flex gap-10 mt-16 flexEnd">
                <button
                  onClick={onClickNo}
                  className="border radius-8 p-8 width-33 font-14"
                >
                  {translations.firebaseModal.dontAllow}
                </button>
                <button
                  onClick={onClickYes}
                  {...classNames("blueBtn p-8 width-33 font-14")}
                >
                  {translations.firebaseModal.allow}
                </button>
              </div>
            </div>
          </div>
        </NotificationPermissionPopup>
      )}
    </>
  );
};

export default FirebaseFCM;
